import { action, computed, observable } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { numberFormat } from 'shared/lib'
import { type ICallingListResponse } from 'entities/AICalling/api/types'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export class CallingListItem extends RowBase<ICallingListResponse> {
  constructor(origin: ICallingListResponse, readonly entities: IEntitiesStore) {
    super(origin)

    makeObservableRowBase(this, {
      _total_calls: observable,
      setTotalCals: action,
      status: computed,
      totalCals: computed,
      inboxes: computed,
      handedOffCalls: computed,
      abandonedCalls: computed,
      resolvedCalls: computed,
    })
  }

  get id() {
    return this.origin.id
  }

  get name() {
    return this.origin.name
  }
  get status() {
    return this.origin.status
  }

  private _total_calls: number | null = null
  get totalCals() {
    if (this._total_calls === null) {
      return null
    }
    return numberFormat({
      value: this._total_calls,
    })
  }
  setTotalCals = (value: number) => {
    this._total_calls = value
  }

  get inboxes() {
    return this.origin.inboxes || []
  }

  get handedOffCalls() {
    return numberFormat({
      value: this.origin.transferred_calls,
    })
  }

  get abandonedCalls() {
    return numberFormat({
      value: this.origin.abandoned_calls,
    })
  }

  get resolvedCalls() {
    return numberFormat({
      value: this.origin.resolved_calls,
    })
  }
}
